<template>
<!-- Infra icons component called to display icons throughout portal -->
  <b-img
    class="infra-icons"
    :src="infraIcons[infraAT]"
    v-bind="thumbnailProps"
    rounded="0"
  ></b-img>
</template>

<script>
/**
 * Infrastructure icon component.
*/
import { infraIcons } from './staticGeom';

export default {
  props: ['infraAT'],
  data() {
    return {
      infraIcons,
      thumbnailProps: { width: 30, height: 30, class: 'm1' },
    };
  },
};
</script>
<style>
.infra-icons {
  margin-right: 0.25rem;
}
</style>
